import React, { useState } from 'react';
import Product from '../../../models/Product';
import { TextInput } from '../../core/text_input';
import styles from './stock_list.module.scss';
import { StockListItem } from './stock_list_item';

type Props = {
  maxLength?: number;
  items: Product[];
  checkedItems: Product[];
  onCheckedItemsChange: (checkedItems: Product[]) => void;
}

/**
 * Renders a selectable list of stock items.
 */
export const StockList: React.FC<Props> = ({
  items, checkedItems, onCheckedItemsChange, maxLength = 10
}) => {
  const [query, setQuery] = useState('');

  let queriedItems = items;
  if (query) {
    queriedItems = queriedItems.filter(item => {
      if (item.name.toLowerCase().startsWith(query.toLowerCase())) {
        return true;
      }

      return false;
    })
  }


  return (
    <div className={styles.container}>
      <header className={styles.headerContainer}>
        <TextInput
          className={styles.query}
          placeholder="Sök"
          value={query}
          onTextValueChange={setQuery} />
      </header>

      <div className={styles.list}>
        {
          queriedItems.map(item => (
            <StockListItem
              item={item}
              key={item.id}
              checked={checkedItems.find(checkedItem => checkedItem.id === item.id) != null}
              onChange={({ currentTarget }) => {
                if (currentTarget.checked) {
                  onCheckedItemsChange([...checkedItems, item].slice(-maxLength));
                } else {
                  onCheckedItemsChange(checkedItems.filter(checkedItem => checkedItem.id !== item.id));
                }
              }} />
          ))
        }
      </div>
    </div>
  )
}